export const environment = {
  production: true,
  heartBeat: {
      url: "https://migration.plexus.applexus.com/api/",
      timeout: 30000
  },
  sr: {
    url: "https://migration.plexus.applexus.com/api/",
    cross_url: "https://migration.plexus.applexus.com/api/",
    socket: {
      url: "http://192.168.4.33:2407",
      path: "/socket/"
    },
    mis_api: "https://migration.plexus.applexus.com/api/mis/"
 }

};
